import { COLOR_MODES } from "@/src/constants/appearance";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import SectionHeader from "../../ui-kit/section-header";
import ColorModeButton from "./color-mode-button";

export type ColorMode = "light" | "dark" | "system";

type ColorModeSectionProps = Readonly<{
  colorMode: ColorMode;
  onSelect: (mode: ColorMode) => void;
}>;

const ColorModeSection = ({ colorMode, onSelect }: ColorModeSectionProps) => {
  const { t } = useTranslation();
  return (
    <View className="gap-4">
      <SectionHeader
        title={t("LABEL_COLOR_MODE")}
        subtitle={t("LABEL_COLOR_MODE_DESC")}
      />

      <View className="flex-row gap-3">
        {COLOR_MODES.map(({ id, labelKey, icon }) => (
          <ColorModeButton
            key={id}
            label={t(labelKey)}
            icon={icon}
            isActive={colorMode === id}
            onPress={() => onSelect(id as ColorMode)}
          />
        ))}
      </View>
    </View>
  );
};

export default ColorModeSection;
